import { Picker } from "antd-mobile";
import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import OfficialPage from '../OfficialPage';

import './BindCellphone.less';

import { TopNav } from '@common/top-nav/TopNav';
export default class BindCellphone extends OfficialPage {
  state = {
    hideVerifyPhone: true,
    hideBindNewPhone: true,
    appLogo: '',
    appTitleLen: 0,
    appTitle: '',
    isQuick: true,
    oldCode: '',
    oldCodeBtnDisabled: false,
    oldCodeStatus: '获取验证码',
    nextStepDisabled: false,
    newPhone: '',
    nationCode: '86',
    intlCode: '',
    newCode: '',
    newCodeBtnDisabled: false,
    newCodeStatus: '获取验证码',
    bindNewPhoneBtnDisabled: false,
    codeInterval: 60,
    phonePreFix: [
      {
        value: 86,
        label: '中国大陆',
        intlCode: 'CN'
      },
      {
        value: 852,
        label: '中国香港',
        intlCode: 'HK'
      },
      {
        value: 853,
        label: '中国澳门',
        intlCode: 'MO'
      },
      {
        value: 886,
        label: '中国台湾',
        intlCode: 'TW'
      },
      {
        value: 1,
        label: '美国',
        intlCode: 'US'
      },
      {
        value: 1,
        label: '加拿大',
        intlCode: 'CA'
      },
      {
        value: 81,
        label: '日本',
        intlCode: 'JP'
      },
      {
        value: 60,
        label: '马来西亚',
        intlCode: 'MY'
      }
    ],
    selectPhonePreFix: [86],
    oldPhonePicCodeUrl: '',
    newPhonePicCodeUrl: '',
    hasMerged: false,
    accountList: [],
    isPageBottom: false,
    isMember: 0
  }
  oldPhonePicCode = ''
  newPhonePicCode = ''
  formerPageRouter = ''
  formerOtherRouter = ''

  constructor(props) {
    super(props);
    document.title = '手机绑定';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    var userInfo = app.getUserInfo()
    if (options.p) {
      this.formerOtherRouter = decodeURIComponent(options.p)
    }
    if (options.is_member == 1) {
      this.setData({
        isMember: 1
      })
    }
    this.formerPageRouter = options.r || ''
    if (userInfo.phone) {
      this.setData({
        hideVerifyPhone: false
      })
      this.refreshOldPhonePicCode()
      this.getAccountInfo()
    } else {
      this.setData({
        hideBindNewPhone: false
      })
      this.refreshNewPhonePicCode()
    }
    let tabPage = app.getTabPagePathArr()
    let pageUrl = this.formerPageRouter
    if (tabPage.indexOf(pageUrl) > -1) {
      this.setData({
        showBackHomeButton: true
      })
    }
    this.dataInitial()
  }

  dataInitial = () => {
    if (app.isLogin()) {
      this.pageDataInitial()
      this.getXcxUserInfo()
    } else {
      app.goLogin({
        success: res => {
          this.pageDataInitial()
          this.getXcxUserInfo()
        }
      })
    }
  }
  pageDataInitial = () => {
    this.setData({
      appLogo: app.globalData.appLogo,
      appTitle: app.globalData.appTitle,
      appTitleLen: app.globalData.appTitle.length
    })
  }
  getXcxUserInfo = () => {
    let has_merged = app.getUserInfo('has_merged')
    this.setData({
      hasMerged: has_merged == undefined ? true : has_merged == 0
    })
  }
  changeType = e => {
    var self = this,
      isQuick = true,
      data = e.currentTarget.dataset
    if (data.type == 'quick') {
      isQuick = true
    } else {
      isQuick = false
    }
    self.setData({
      isQuick: isQuick
    })
  }
  getAccountInfo = callback => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetAccountIfCouldMerge',
      data: {},
      success: function(res) {
        that.setData({
          accountList: res.data.list || []
        })
        typeof callback === 'function' && callback(res)
      }
    })
  }
  sendCodeToOldPhone = () => {
    var that = this
    if (this.data.oldCodeBtnDisabled) {
      return
    }
    if (!this.oldPhonePicCode) {
      app.showModal({
        content: '请输入图形验证码'
      })
      return
    }
    this.setData({
      oldCodeStatus: '正在发送...',
      oldCodeBtnDisabled: true
    })
    app.sendRequest({
      url: '/index.php?r=AppData/PhoneCode',
      data: {
        pic_code: this.oldPhonePicCode
      },
      success: function() {
        var second = that.data.codeInterval,
          interval
        interval = setInterval(function() {
          if (second < 0) {
            clearInterval(interval)
            that.setData({
              oldCodeStatus: '获取验证码',
              oldCodeBtnDisabled: false
            })
          } else {
            that.setData({
              oldCodeStatus: second + 's'
            })
            second--
          }
        }, 1000)
      },
      successStatusAbnormal: function() {
        that.setData({
          oldCodeStatus: '获取验证码',
          oldCodeBtnDisabled: false
        })
      },
      fail: function() {
        that.setData({
          oldCodeStatus: '获取验证码',
          oldCodeBtnDisabled: false
        })
      }
    })
  }
  inputOldCode = e => {
    this.setData({
      oldCode: e.target.value
    })
  }
  nextStep = () => {
    var that = this
    if (!this.data.oldCode) {
      app.showModal({
        content: '请输入验证码'
      })
      return
    }
    if (this.data.nextStepDisabled) {
      return
    }
    this.setData({
      nextStepDisabled: true
    })
    app.sendRequest({
      url: '/index.php?r=AppData/VerifyPhone',
      method: 'post',
      data: {
        code: this.data.oldCode
      },
      success: function() {
        that.setData({
          hideVerifyPhone: true,
          hideBindNewPhone: false
        })
        that.refreshNewPhonePicCode()
      },
      complete: function() {
        that.setData({
          nextStepDisabled: false
        })
      }
    })
  }
  inputPhone = e => {
    this.setData({
      newPhone: e.target.value
    })
  }
  inputNewCode = e => {
    this.setData({
      newCode: e.target.value
    })
  }
  sendCodeToNewPhone = () => {
    var that = this,
      newPhone = this.data.newPhone,
      phone =
        this.data.nationCode != '86'
          ? this.data.nationCode + '-' + newPhone
          : newPhone,
      isPhoneNumber = /^1\d{10}$/.test(phone) || /^\+?\d+-\d+$/.test(phone)
    app.getStorage({
      key: 'session_key',
      success: function(res) {
        if (res.data == '') {
          app.showModal({
            content: '未获取授权，验证码获取失败'
          })
          return
        }
      }
    })
    if (!this.newPhonePicCode) {
      app.showModal({
        content: '请输入图形验证码'
      })
      return
    }
    if (!isPhoneNumber) {
      app.showModal({
        content: '请输入正确的手机号码'
      })
      return
    }
    if (this.data.newCodeBtnDisabled) {
      return
    }
    this.setData({
      newCodeStatus: '正在发送...',
      newCodeBtnDisabled: true
    })
    app.sendRequest({
      url: '/index.php?r=AppData/NewPhoneCode',
      method: 'post',
      data: {
        phone: phone,
        pic_code: this.newPhonePicCode
      },
      success: function(res) {
        var second = that.data.codeInterval,
          interval
        interval = setInterval(function() {
          if (second < 0) {
            clearInterval(interval)
            that.setData({
              newCodeStatus: '获取验证码',
              newCodeBtnDisabled: false
            })
          } else {
            that.setData({
              newCodeStatus: second + 's'
            })
            second--
          }
        }, 1000)
      },
      successStatusAbnormal: function() {
        that.setData({
          newCodeStatus: '获取验证码',
          newCodeBtnDisabled: false
        })
      },
      fail: function() {
        that.setData({
          newCodeStatus: '获取验证码',
          newCodeBtnDisabled: false
        })
      }
    })
  }
  bindNewPhone = () => {
    var that = this,
      newPhone = this.data.newPhone,
      newCode = this.data.newCode,
      nationCode = this.data.nationCode != '86' ? this.data.nationCode : '',
      intlCode = this.data.intlCode,
      phone = nationCode ? nationCode + '-' + newPhone : newPhone,
      isPhoneNumber = /^1\d{10}$/.test(phone) || /^\+?\d+-\d+$/.test(phone)
    if (!newPhone || !newCode) {
      return
    }
    if (!isPhoneNumber) {
      app.showModal({
        content: '请输入正确的手机号码'
      })
      return
    }
    if (this.data.bindNewPhoneBtnDisabled) {
      return
    }
    this.setData({
      bindNewPhoneBtnDisabled: true
    })
    app.sendRequest({
      url: '/index.php?r=AppData/XcxVerifyNewPhone',
      mehtod: 'post',
      data: {
        phone: phone,
        code: newCode,
        nationCode: nationCode,
        intlCode: intlCode
      },
      success: function(res) {
        app.setUserInfoStorage({
          phone: newPhone
        })
        app.showToast({
          title: '绑定成功',
          icon: 'success',
          success: function() {
            that.getAccountInfo(function() {
              if (that.data.hasMerged && that.data.accountList.length > 0) {
                app.turnToPage('/userCollect', 1)
              } else if (that.formerOtherRouter) {
                app.turnToPage(
                  '/' + that.formerOtherRouter + '&from=bindCellphone',
                  true
                )
              } else if (that.data.isMember === 1) {
                app.turnToPage(
                  '/' +
                  that.formerPageRouter +
                  '?is_member=1',
                  1
                )
              } else {
                app.turnToPage(
                  '/' +
                  that.formerPageRouter,
                  1
                )
              }
            })
          }
        })
      },
      fail: function(res) {
        app.showModal({
          content: '绑定失败' + res.data
        })
      },
      complete: function() {
        that.setData({
          bindNewPhoneBtnDisabled: false
        })
      }
    })
  }
  getPhoneNumber = e => {
    let that = this
    if (
      e.detail.errMsg == 'getPhoneNumber:fail user deny' ||
      e.detail.errMsg == 'getPhoneNumber:fail:user denied' ||
      e.detail.errMsg == 'getPhoneNumber:fail:cancel to confirm login'
    ) {
      console.log(e.detail.errMsg)
      app.addLog(e.detail)
    } else if (
      e.detail.errMsg == 'getPhoneNumber:fail 该 appid 没有权限' ||
      e.detail.errMsg ==
      'getPhoneNumber:fail jsapi has no permission, event…sg=permission got, detail=jsapi has no permission'
    ) {
      app.showModal({
        content:
          '该appid没有权限，目前该功能针对非个人开发者，且完成了认证的小程序开放（不包含海外主体）'
      })
      app.addLog(e.detail)
    } else if (e.detail.encryptedData) {
      app.checkSession(function() {
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=AppUser/GetPhoneNumber',
          data: {
            encryptedData: e.detail.encryptedData,
            iv: e.detail.iv
          },
          success: function(res) {
            app.setUserInfoStorage({
              phone: res.data
            })
            app.showToast({
              title: '授权成功',
              icon: 'success',
              success: function() {
                that.getAccountInfo(function() {
                  if (that.data.hasMerged && that.data.accountList.length > 0) {
                    app.turnToPage('/userCollect', 1)
                  } else if (that.formerOtherRouter) {
                    app.turnToPage(
                      '/' + that.formerOtherRouter + '&from=bindCellphone',
                      true
                    )
                  } else if (that.data.isMember) {
                    app.turnToPage(
                      '/' +
                      that.formerPageRouter +
                      '?is_member=1',
                      1
                    )
                  } else {
                    app.turnToPage(
                      '/' +
                      that.formerPageRouter,
                      1
                    )
                  }
                })
              }
            })
          },
          successStatus5: function() {
            app.showModal({
              content: '获取手机号失败，请再次点击授权获取'
            })
            // app.goLogin({
            //   success: function() {
            //     app.showModal({
            //       content: '获取手机号失败，请再次点击授权获取'
            //     })
            //   },
            //   fail: function() {
            //     app.showModal({
            //       content: '获取手机号失败，请再次点击授权获取'
            //     })
            //   }
            // })
          }
        })
      })
    } else {
      app.showModal({
        content: '无法获取到手机号，请检查该appid是否有权限'
      })
      app.addLog(e)
    }
  }
  inputOldPhonePicCode = e => {
    var value = e.target.value
    this.oldPhonePicCode = value
  }
  inputNewPhonePicCode = e => {
    var value = e.target.value
    this.newPhonePicCode = value
  }
  refreshOldPhonePicCode = () => {
    this.setData({
      oldPhonePicCodeUrl:
        (app.getSiteBaseUrl() || '') +
        '/index.php?r=Login/GetIdentifyCode&i=' +
        parseInt(Math.random() * 10000000)
    })
  }
  refreshNewPhonePicCode = () => {
    this.setData({
      newPhonePicCodeUrl:
        (app.getSiteBaseUrl() || '') +
        '/index.php?r=Login/GetIdentifyCode&i=' +
        parseInt(Math.random() * 10000000)
    })
  }
  backToHomePage = () => {
    app.turnToPage(
      '/' +
      app.globalData.homepageRouter
    )
  }
  bindPickerChange = e => {
    let nationCode
    let intlCode
    this.state.phonePreFix.some(ppf => {
      let f = ppf.value === e[0];
      if (f) {
        nationCode = ppf.value;
        intlCode = ppf.intlCode;
      }
      return f;
    })
    this.setData({
      selectPhonePreFix: e,
      nationCode: nationCode,
      intlCode: intlCode
    })
  }

  render() {
    const {
      isPageBottom,
      appLogo,
      appTitleLen,
      appTitle,
      hideVerifyPhone,
      oldPhonePicCodeUrl,
      oldCodeStatus,
      hideBindNewPhone,
      isQuick,
      nationCode,
      phonePreFix,
      selectPhonePreFix,
      newPhonePicCodeUrl,
      newCodeStatus,
      newPhone,
      newCode,
      showBackHomeButton
    } = this.state
    return (
      <div className="official-page bind-cellphone">
        <TopNav title="手机绑定" />
        <div id="bindPhonePage">
          <div
            className="page bindPhone-wrap"
            id="bindPhonePage"
            data-router="bindPhonePage"
            style={convertLineStyleData(isPageBottom ? 'padding-bottom:600rpx' : '')}
          >
            <div className="header-wrap">
              <div className="image-wrap">
                <img src={appLogo} />
              </div>
              <div
                className="title-wrap"
                style={convertLineStyleData('font-size:' + (appTitleLen >= 8 ? '30rpx' : '55rpx'))}
              >
                {appTitle}
              </div>
            </div>
            <div className="verify-wrap" hidden={hideVerifyPhone}>
              <div className="verify-row getCode">
                <input
                  // placeholderClass="phcolor"
                  className="pic-code-input"
                  onInput={this.inputOldPhonePicCode}
                  placeholder="图片验证码"
                />
                <div className="pic-code-wrap">
                  <img
                    className="pic-code"
                    mode="aspectFit"
                    src={oldPhonePicCodeUrl}
                    onClick={this.refreshOldPhonePicCode}
                  />
                </div>
              </div>
              <div className="verify-row postCode">
                <input
                  // placeholderClass="phcolor"
                  onInput={this.inputOldCode}
                  placeholder="请输入验证码"
                />
                <div
                  className="get-code-btn"
                  onClick={this.sendCodeToOldPhone}
                >
                  {oldCodeStatus}
                </div>
              </div>
              <div className="option-btn next-step" onClick={this.nextStep}>
                下一步
              </div>
            </div>
            <div className="bind-new-tel-wrap" hidden={hideBindNewPhone}>
              <div className="main-wrap">
                {/* <div className="options">
                  <div
                    className={'quick-bind ' + (isQuick ? 'active' : '')}
                    data-type="quick"
                    onClick={this.changeType}
                  >
                    快速绑定
                  </div>
                  <div
                    className={'message-check ' + (!isQuick ? 'active' : '')}
                    data-type="message"
                    onClick={this.changeType}
                  >
                    短信验证
                  </div>
                </div> */}
                {/* {isQuick ? (
                  <React.Fragment>
                    <button
                      className="authorization"
                      // openType="getPhoneNumber"
                      // onGetphonenumber={this.getPhoneNumber}
                    >
                      <span className="ico-moon icon-full-weixin"></span>
                      <div>微信授权登录</div>
                    </button>
                  </React.Fragment>
                ) : ( */}
                  <React.Fragment>
                    <div className="any-message">
                      <div className="verify-row phonenum">
                        <Picker
                          className="prefix-code"
                          data={phonePreFix}
                          value={selectPhonePreFix}
                          cols={1}
                          onOk={v => this.bindPickerChange(v)}
                        >
                          <div>{'+' + nationCode}</div>
                        </Picker>
                        <span className="ico-moon icon-rightarrow"></span>
                        <input
                          // placeholderClass="phcolor"
                          className="code-tel"
                          onInput={this.inputPhone}
                          placeholder="手机号"
                          // cursorSpacing="200"
                        />
                      </div>
                      <div className="verify-row getCode">
                        <input
                          // placeholderClass="phcolor"
                          className="pic-code-input"
                          // cursorSpacing="140"
                          onInput={this.inputNewPhonePicCode}
                          placeholder="图片验证码"
                        />
                        <div className="pic-code-wrap">
                          <img
                            className="pic-code"
                            mode="aspectFit"
                            src={newPhonePicCodeUrl}
                            onClick={this.refreshNewPhonePicCode}
                          />
                        </div>
                      </div>
                      <div className="verify-row postCode">
                        <input
                          // placeholderClass="phcolor"
                          onInput={this.inputNewCode}
                          placeholder="请输入验证码"
                          // cursorSpacing="80"
                        />
                        <div
                          className="get-code-btn"
                          onClick={this.sendCodeToNewPhone}
                        >
                          {newCodeStatus}
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        'option-btn bind-new-tel-btn ' +
                        (!newPhone || !newCode ? 'disabled' : '')
                      }
                      onClick={this.bindNewPhone}
                    >
                      登录
                    </div>
                  </React.Fragment>
                {/* )} */}
              </div>
            </div>
            {showBackHomeButton && (
              <div
                className="back-home-btn icon-back-to-home ico-moon"
                onClick={this.backToHomePage}
              ></div>
            )}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/bind-cellphone/BindCellphone.jsx